import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class VolunteerScreen extends React.Component {

    constructor(props) {
        super(props);

        const readonly = props.args.caller == "event-participant"

        this.state = {  disabled: readonly,
                        locationOptions: [], 
                        currentVolunteer: {id: null, 
                                            firstname: "",
                                            surname: "",
                                            locationid: "",
                                            location: "", 
                                            region: "", 
                                            phone: "",
                                            email: ""}};

        this.handleChangeFirstname = this.handleChangeFirstname.bind(this);  
        this.handleChangeSurname = this.handleChangeSurname.bind(this);  
        this.handleChangeLocation = this.handleChangeLocation.bind(this); 
        this.handleChangePhone = this.handleChangePhone.bind(this); 
        this.handleChangeEmail = this.handleChangeEmail.bind(this); 
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.volunteer && this.props.args.volunteer.length > 0) {
            BaseApi.get("/volunteer", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.volunteer}, withCredentials: true})
            .then(res => { 
                this.setState({currentVolunteer: res.data})
            })    
            .catch()
        }

        BaseApi.get("/locations", {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, params: {name: ""}, withCredentials: true})
        .then(res => {
            const locationOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({locationOptions: locationOptions})
        })    
        .catch()
    }


    save(event) {
        BaseApi.post('/volunteer', this.state.currentVolunteer, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeFirstname(event) {
        var currentVolunteer = this.state.currentVolunteer
        currentVolunteer.firstname = event.target.value
        this.setState({currentVolunteer: currentVolunteer})
    }

    handleChangeSurname(event) {
        var currentVolunteer = this.state.currentVolunteer
        currentVolunteer.surname = event.target.value
        this.setState({currentVolunteer: currentVolunteer})
    }

    handleChangeLocation(selectedOption) {
        var currentVolunteer = this.state.currentVolunteer
        currentVolunteer.location = selectedOption.label
        currentVolunteer.locationid = selectedOption.value
        this.setState({currentVolunteer: currentVolunteer})
    }

    handleChangePhone(event) {
        var currentVolunteer = this.state.currentVolunteer
        currentVolunteer.phone = event.target.value
        this.setState({currentVolunteer: currentVolunteer})
    }

    handleChangeEmail(event) {
        var currentVolunteer = this.state.currentVolunteer
        currentVolunteer.email = event.target.value
        this.setState({currentVolunteer: currentVolunteer})
    }

    openEvents() {
        this.props.navigate("events", 
        {caller: "volunteer", callargs: this.props.args, volunteer: this.props.args.volunteer})
    }

    render() {
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Волонтер"}/>

                <div class="row mt-4">
                    <div class="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {this.state.currentVolunteer.id ? "Редактирование волонтера" : "Новый волонтер"}
                                </h6>
                                <form>
                                    <div class="form-group">
                                        <label for="name">Имя:</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="name" 
                                            disabled={this.state.disabled}
                                            value={this.state.currentVolunteer.firstname} 
                                            onChange={this.handleChangeFirstname} 

                                        />
                                        <label for="surname">Фамилия:</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="surname" 
                                            disabled={this.state.disabled}
                                            value={this.state.currentVolunteer.surname} 
                                            onChange={this.handleChangeSurname} 
                                        />
                                        <label for="phone">Телефон:</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="phone" 
                                            disabled={this.state.disabled} 
                                            value={this.state.currentVolunteer.phone} 
                                            onChange={this.handleChangePhone} 
                                        />
                                        <label for="mail">Email:</label>
                                        <input 
                                            type="text" 
                                            class="form-control" 
                                            id="mail"  
                                            disabled={this.state.disabled}
                                            value={this.state.currentVolunteer.email} 
                                            onChange={this.handleChangeEmail} 
                                        />
                                        <label for="location">Локация:</label>
                                        <Select 
                                            options= {this.state.locationOptions} 
                                            id="location" 
                                            onChange={this.handleChangeLocation}
                                            placeholder={this.state.currentVolunteer.location} 
                                            isDisabled={this.state.disabled}     
                                        />
                                        <div className="mt-4 d-flex justify-content-end">
                                            {!this.state.disabled &&
                                            <button type="submit" className="btn btn-primary" onClick={this.save}>
                                                Сохранить
                                            </button>
                                            }
                                        </div>        
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 mt-4 mt-lg-0">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Действия</h6>
                                {this.state.currentVolunteer.id &&(
                                    <div>
                                        <button 
                                            class="btn btn-outline-primary w-100 mb-2" 
                                            onClick={()=>{this.openEvents()}}>
                                                События
                                        </button>    
                                    </div>
                                )} 
                                {!this.state.currentVolunteer.id && (
                                    <p className="text-muted mb-0">
                                        Дополнительные действия станут доступны после сохранения записи.
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/*                
                <div class="row mt-5">
                    <div class="col-md-6">
                        <form>
                            <div class="form-group">
                                <label for="name">Имя:</label>
                                <input type="text" class="form-control" id="name" value={this.state.currentVolunteer.firstname} onChange={this.handleChangeFirstname} />
                                <label for="surname">Фамилия:</label>
                                <input type="text" class="form-control" id="surname" value={this.state.currentVolunteer.surname} onChange={this.handleChangeSurname} />
                                <label for="phone">Телефон:</label>
                                <input type="text" class="form-control" id="phone"  value={this.state.currentVolunteer.phone} onChange={this.handleChangePhone} />
                                <label for="mail">Email:</label>
                                <input type="text" class="form-control" id="mail"  value={this.state.currentVolunteer.email} onChange={this.handleChangeEmail} />
                                <label for="location">Локация:</label>
                                <Select options= {this.state.locationOptions} 
                                        id="location" 
                                        onChange={this.handleChangeLocation}
                                        placeholder={this.state.currentVolunteer.location}    
                                        />
                            </div>
                        </form>
                    </div>
                    <div class="col-md-3 offset-3">
                        <div class="row">
                            <button class="btn btn-primary w-100" onClick={()=>{this.openEvents()}}>События</button>   
                        </div>
                        <div class="row mt-3">
                            <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                        </div>
                    </div>
                </div>
                */}
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/volunteer.js